@if (type=='detail' || type=='summary') {
  <div class="main-content-container">
    <div style="background: #F1F3F6;" class="forfullwidth col-12 col-sm-12 col-xs-12 col-lg-12 col-xl-12 pt-2 pb-3"><!--adding class for responsive-->
      @for (field of config.banner; track field) {
        <div class="col-4 d-inline-block pt-2 text-center"><b>{{field.label | translate | async}}
        </b>: {{userName[field['key']]}}</div>
      }
      <div [ngClass]="type=='detail'?'col-4':'col-3'" class="d-inline-block pt-2 text-center"><b>{{'Date' | translate | async}} :
      </b>{{date| dateTimeFormat}}</div>
      <!-- <div class="col-1 mb-3 d-inline-block pt-2 text-center"><button *ngIf="type=='summary'" type="button" class="rounded-circle p-3 danger-btn" (click)="changeStatus()">
      <i class="fa fa-power-off"></i></button></div> -->
    </div>
    <div class="main-container-body">
      <ul class="base-tab">
        @for (layout_key of this.headers; track layout_key) {
          <li class="nav-item">
            <a class="nav-link kx-w-80 text-center" (click)="activeTab(layout_key.code)" data-toggle="tab" [ngClass]="layout_key.code == currentTab?'active':''" id="{{layout_key.code}}" role="tab">{{layout_key.display}}</a>
          </li>
        }
      </ul>
      @if (showGrid) {
        <div class="base-tab-content" id="_layout_id">
          @if (this.fields && filterList && this.newDataList) {
            <dhs-data-grid [fields]="this.fields.fields" [config]="configList"
              (bulkActionClicked)="onBulkActionClicked($event)"
              (bindGrid)="bindDataToGrid($event)" (onFilterChange)="search($event)" (editEllipseClick)="ellipsfun($event)" [filterFieldGroup]="this.filterList" [data]="this.newDataList" (onPageChanges)="pageChanges($event)" (onLimitChange)="limitChanged($event)" (configValues)="getConfigValues($event)">
            </dhs-data-grid>
          }
          @if (_currentData.amountData && _currentData.dynamic_keys && fields.amountResource.datasource.type !='multiple') {
            <div class="table-summary">
              @for (amount of _currentData.amountData; track amount) {
                <div>
                  {{amount.key}}<b>&nbsp;{{amount.value}} </b>
                </div>
              }
            </div>
          }
          @if (_currentData.amountData && !_currentData.dynamic_keys && fields.amountResource.datasource.type =='multiple') {
            <ng-continer>
              @for (amount of _currentData.amountData; track amount) {
                <div class="table-summary">
                  <div><b>{{amount[_currentData.headerKey]}} : {{amount[_currentData.headerValue]}}</b></div>
                  @for (a of amount.extra_data | keyvalue; track a) {
                    <div>
                      {{a.key}}<b>&nbsp;{{a.value}} </b>
                    </div>
                  }
                </div>
              }
            </ng-continer>
          }
        </div>
      }
    </div>
  </div>
}
@if (showGrid) {
  <div class="main-content-container">
    <div class="main-container-body">
      @if (fields && filterList && newDataList != null && callGRID) {
        <dhs-data-grid [fields]="this.fields.fields" [config]="configList" [data]="newDataList" (bulkActionClicked)="onBulkActionClicked($event)" [filterFieldGroup]="this.filterList" [bulkActionsConfig]="fields.bulkAction" [rowClick]="fields.rowClick"
          (bindGrid)="bindDataToGrid($event)" (editEllipseClick)="ellipsfun($event)" (onFilterChange)="search($event)" (onPageChanges)="pageChanges($event)" (onLimitChange)="limitChanged($event)" (configValues)="getConfigValues($event)">
        </dhs-data-grid>
      }
      @if (_currentData.amountData && _currentData.dynamic_keys &&  fields.amountResource.datasource.type !='multiple') {
        <div class="table-summary">
          @for (amount of _currentData.amountData; track amount) {
            <div>
              {{amount.key}}<b>&nbsp;{{amount.value}} </b>
            </div>
          }
        </div>
      }
      @if (callSummary) {
        <div>
          @if (fields!=undefined && fields.amountResource!=undefined && fields.amountResource.datasource!=undefined && fields.amountCall!=undefined && !fields.amountCall && newDataList!=undefined && newDataList.resource!=undefined && newDataList.resource.length!=undefined && newDataList.resource.length>0 && !fields['hideViewSummary']) {
            <button
            type="button" (click)="getAmountInfo()" class="primary-btn ml-2 _summary-button">View Summary</button>
          }
        </div>
      }
      @if (_currentData.amountData && !_currentData.dynamic_keys && fields.amountCall!=undefined && fields.amountCall && fields.amountResource.datasource.type =='multiple') {
        <ng-continer>
          @for (amount of _currentData.amountData; track amount) {
            <div class="table-summary">
              {{amount.key}}:<b>&nbsp;{{amount.value}} </b>
              <!-- <div *ngFor="let a of amount.extra_data | keyvalue">
              {{a.key}}<b>&nbsp;{{a.value}} </b>
            </div> -->
          </div>
        }
      </ng-continer>
    }
  </div>
</div>
}
@if (type=='collection_detail') {
  <div class="main-content-container">
    <div class="main-container-body">
      <div class="col-12 col-sm-12 col-xs-12 col-lg-12 col-xl-12 text-center p-2"><b>{{"field.label.cashier_collection_detail" | translate | async }}</b>
      <span class="pull-right">{{date| dateTimeFormat}}</span>
    </div>
    <ul class="base-tab">
      @for (layout_key of this.headers; track layout_key) {
        <li class="nav-item">
          <a class="nav-link kx-w-80 text-center" (click)="activeTab(layout_key.code)" data-toggle="tab" [ngClass]="layout_key.code == currentTab?'active':''" id="{{layout_key.code}}" role="tab">{{layout_key.display}}</a>
        </li>
      }
    </ul>
    @if (fields && filterList && newDataList) {
      <dhs-data-grid [fields]="this.fields.fields" [config]="configList" [data]="this.newDataList" (bulkActionClicked)="onBulkActionClicked($event)" [filterFieldGroup]="this.filterList" [bulkActionsConfig]="fields.bulkAction" [rowClick]="fields.rowClick"
        (bindGrid)="bindDataToGrid($event)" (editEllipseClick)="ellipsfun($event)" (onPageChanges)="pageChanges($event)" (onLimitChange)="limitChanged($event)" (configValues)="getConfigValues($event)">
      </dhs-data-grid>
    }
    @if (_currentData.amountData && _currentData.dynamic_keys && fields.amountResource.datasource.type !='multiple') {
      <div class="table-summary">
        @for (amount of _currentData.amountData; track amount) {
          <div>
            {{amount.key}}<b>&nbsp;{{amount.value}} </b>
          </div>
        }
      </div>
    }
    @if (_currentData.amountData && !_currentData.dynamic_keys && fields.amountResource.datasource.type =='multiple') {
      <ng-continer>
        @for (amount of _currentData.amountData; track amount) {
          <div class="table-summary">
            <div><b>{{amount[_currentData.headerKey]}} : {{amount[_currentData.headerValue]}}</b></div>
            @for (a of amount.extra_data | keyvalue; track a) {
              <div>
                {{a.key}}<b>&nbsp;{{a.value}} </b>
              </div>
            }
          </div>
        }
      </ng-continer>
    }
  </div>
</div>
}
@if (type=='detailed_breakup'||type=='summary_breakup') {
  <div class="main-content-container">
    <div class="main-container-body">
      @if (type=='detailed_breakup') {
        <div class="col-12 col-sm-12 col-xs-12 col-lg-12 col-xl-12 text-center p-2 three">
          <div class="pl-2 pr-2 pull-left">
            <a class="d-inline-flex" href="javascript:void(0)" (click)="goBack()">
              <img src="assets/images/grid-back.png">
            </a>
          </div>
          <b>CASHIER SUMMARY</b>
          <span class="pull-right">{{date| dateTimeFormat}}</span>
        </div>
      }
      @if (type=='summary_breakup') {
        <div class="col-12 col-sm-12 col-xs-12 col-lg-12 col-xl-12 text-center p-2 four">
          <div class="pl-2 pr-2 pull-left">
            <a class="d-inline-flex" href="javascript:void(0)" (click)="goBack()">
              <img src="assets/images/grid-back.png">
            </a>
          </div>
          <b>CASHIER DETAIL</b>
          <span class="pull-right">{{date| dateTimeFormat}}</span>
        </div>
      }
      @if (fields && filterList && newDataList) {
        <dhs-data-grid [fields]="this.fields.fields" [config]="configList" [data]="this.newDataList" (bulkActionClicked)="onBulkActionClicked($event)" [bulkActionsConfig]="fields.bulkAction"
          (bindGrid)="bindDataToGrid($event)" (editEllipseClick)="ellipsfun($event)" (onPageChanges)="pageChanges($event)" (onLimitChange)="limitChanged($event)" (configValues)="getConfigValues($event)">
        </dhs-data-grid>
      }
      @if (_currentData.amountData && _currentData.dynamic_keys && fields.amountResource.datasource.type !='multiple') {
        <div class="table-summary">
          @for (amount of _currentData.amountData; track amount) {
            <div>
              {{amount.key}}<b>&nbsp;{{amount.value}} </b>
            </div>
          }
        </div>
      }
      @if (_currentData.amountData && !_currentData.dynamic_keys && fields.amountResource.datasource.type =='multiple') {
        <ng-continer>
          @for (amount of _currentData.amountData; track amount) {
            <div class="table-summary">
              <div><b>{{amount[_currentData.headerKey]}} : {{amount[_currentData.headerValue]}}</b></div>
              @for (a of amount.extra_data | keyvalue; track a) {
                <div>
                  {{a.key}}<b>&nbsp;{{a.value}} </b>
                </div>
              }
            </div>
          }
        </ng-continer>
      }
    </div>
  </div>
}